import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from '../Icon/Icon';

export const PricingPlaceholder = () => (
  <div className="PricingPlaceholder">
    <div className="PricingPlaceholder-header">

      <div className="PricingPlaceholder-placeholder">
        <h3 className="PricingPlaceholder-placeholder-title">
          <div className="PricingPlaceholder-placeholder-arrow">
            <Icon name="ic-arrow" />
          </div>
          <FormattedMessage id="IT_TAKES_A_MINUTE" />
        </h3>

        <FormattedMessage tagName="small" id="ENTER_DETAILS" />
      </div>

    </div>

    <div className="PricingPlaceholder-body">

      <div className="PricingPlaceholder-loaders">
        <div className="PricingPlaceholder-loader-1" />
        <div className="PricingPlaceholder-loader-2" />
        <div className="PricingPlaceholder-loader-3" />
      </div>

    </div>
  </div>
);
